import Hero from "../components/hero/Hero";

function Home() {
  return <Hero />;
}

export default Home;
